import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Dropdown from '@/components/Dropdown/Dropdown';
import '@/assets/styles/components/fund-management/fund-management-withdrawal-mobile.scss';
import { getSafe } from '@/helpers/global';
import { formatFunctions, Validators, utilsFunction } from '../../../../helpers/functions';
import { settingConfigs } from '../../../../configurations';
import { fundActions } from '../../../../actions/trading/fund.actions'
import { PARAMS } from '../../../../constants/params';
import { SERVICES_RESP as servicesResp , Icons} from '../../../../configurations';
import Tips from '../../../../components/Tips/Tips';
import { opencashDWResultDialog } from '../../../../actions/app';
import { dataType } from '@/constants/data-type';
import { REFRESH_DATA } from '@/constants/app';
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '../../../../components/Spinner/LoadingLayer';

const CHEQUE = 'Q', TRANSFER = 'L',  BANKTRANSFER = 'E';
const INPUT = 'I', MODIFY = 'M';
class FundManagementWithdrawal extends React.Component {
    constructor(props) {
        super(props);
        props.innerRef(this)
        this.state = {
            withdrawalBankAccountOption: [],
            otherWithdrawalBankAccountOption: this.props.OtherWithdrawalBankAccount,
            newOtherWithdrawalBankAccount: [],
            selectWBankAC: [],
            settleMethod: CHEQUE,
            amount: '',
            selectCurrencyID: '',
            withdrawableBalance: '-',
            errorMessage: '',
            remark: '',
            isModify: false,
            modifyFundData: {},
            operation: INPUT,
            TTCcrency: [{
                id: 1,
                value: 'HKD',
                label: 'HKD'
              },
              {
                id: 2,
                value: 'USD',
                label: 'USD'
              }],
            inputBankAccount: '',
            inputBankID: '',
            defaultBankAccount: true,
            // isSelect: true,
            fee: '0.00',
            creditedAmount: '0.00',
            isLoading: false,
        }
    }

    selectSettleMethod = (val) => {
        this.setState({
            // selectCurrencyID: this.props.ccy[0].value,
            settleMethod: val[0].value,
            // isSelect: true,
            // amount: '',
            // remark: '',
            // errorMessage: '',
            // inputBankAccount: '',
            // inputBankID: '',
            // defaultBankAccount: true
        }, () => {
                this.setWithdrawableBalance()
        })
    }

    formatNumber() {
        let amountValue = this.amountInput.value;
        if (amountValue) {
            setTimeout(() => {
                amountValue = parseFloat(amountValue);
                this.setState({
                    amount: amountValue
                })
            }, 0)
        }
    }

    inputAmount=()=>{
        let amountValue = this.amountInput.value;
        amountValue = amountValue.replaceAll(settingConfigs.PRICE.thousandSeparator, '');
        if (amountValue && amountValue.length < 16) {
            if (Validators.currency(amountValue, settingConfigs.PRICE.decimalSeparator, settingConfigs.PRICE.decimal)) {
                    this.setState({ amount: amountValue })
                    this.cashDepositWithdrawalFee(amountValue)
            }  
        } else {
            this.setState({ amount: '', creditedAmount: '0.00' })
        }
    }

    cashDepositWithdrawalFee = utilsFunction.debounce ((amountValue)=>{
        this.cashDepositWithdrawalFeeEnquiry(()=>{
            if(amountValue === this.amountInput.value){
                this.setState({
                    creditedAmount: amountValue - this.state.fee
                })
            }
        })
     },500)

    cashDepositWithdrawalFeeEnquiry(callback) {
        const { language, currentTradingAccount, user } = this.props;
        const { clientID, tradingAccSeq } = currentTradingAccount;
        let amountValue = this.amountInput.value;
        let params = {
            [PARAMS.CLIENT_ID]: clientID,
            [PARAMS.TRADING_ACCOUNT_ID]: clientID,
            [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
            [PARAMS.LANGUAGE]: language.lang,
            tranType: 'W',
            settleCurrencyID: this.state.selectCurrencyID,
            amount: amountValue,
            settleMethod: this.state.settleMethod
        }
        if(this.state.settleMethod === TRANSFER){
            params.settleMethod = 'L'
        }else{
            params.settleMethod = this.state.settleMethod
        }
        this.props.cashDepositWithdrawalFeeEnquiry(params, res => {
            if (res.result.errorCode === servicesResp.SUCCESS_CODE) {
                if (res.result.feesList.length > 0) {
                    if (res.result.feesList[0].feeAmount !== null) {
                        this.setState({
                            fee: res.result.feesList[0].feeAmount
                        },()=>{
                            typeof callback === 'function' && callback()
                        })
                    } else {
                        this.setState({
                            fee: '0.00'
                        },()=>{
                            typeof callback === 'function' && callback()
                        })
                    }
                } else {
                    this.setState({
                        fee: '0.00'
                    },()=>{
                        typeof callback === 'function' && callback()
                    })
                }
            }
        })
    }

    withdrawalAll() {
        this.setState({
            amount: parseFloat(this.state.withdrawableBalance.replaceAll(',', ''))
        },()=>{
            this.cashDepositWithdrawalFeeEnquiry(()=>{
                this.setState({
                    creditedAmount: parseFloat(this.state.withdrawableBalance.replaceAll(',', '')) - this.state.fee
                })
            })
        })
    }

    resetOption = () => {
        const { ccy, settleMethodOption } = this.props;
        this.setState({
            selectCurrencyID: ccy[0].value,
            settleMethod: CHEQUE,
            amount: '',
            remark: '',
            errorMessage: '',
            isModify: false,
            inputBankAccount: '',
            inputBankID: '',
            // isSelect: true,
            fee: '0.00',
            creditedAmount: '0.00',
            defaultBankAccount: true,
            modifyFundData: {},
            operation: INPUT
        }, () => {
            this.CurrencyIDToBankAC([ccy[0]]);
        })
        this.withdrawalCurrencyIDOption.setValue([ccy[0]]);
        this.settleMethodOptionWithdrawalRef.setValue([settleMethodOption[0]]); 
    }

    cashSubmit = () => {
        const { language, currentTradingAccount, user, pageID } = this.props;
        const { amount, selectCurrencyID, settleMethod, remark, selectWBankAC, operation, isModify, modifyFundData, inputBankAccount, TTCcrency, inputBankID, defaultBankAccount } = this.state
        const { clientID, tradingAccSeq } = currentTradingAccount;
        const content = document.getElementsByClassName("content")[0]
        let isValid = false;
        content.scrollTop = 0
        this.setState({
            errorMessage: ''
        })
        if (!selectWBankAC) {
            this.setState({
                errorMessage: getSafe(() => language.fund_management_not_found_bank)
            })
        } else if (!this.state.amount) {
            this.setState({
                errorMessage: getSafe(() => language.fund_management_enter_amount)
            })
        } else {
            isValid = true;
        }
        if (isValid) {
            this.setState({isLoading : true})
            let params = {
                [PARAMS.CLIENT_ID]: clientID,
                [PARAMS.TRADING_ACCOUNT_ID]: clientID,
                [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
                [PARAMS.LANGUAGE]: language.lang,
                [PARAMS.OPERATION]: operation,
                [PARAMS.AMOUNT]: String(amount),
                [PARAMS.CURRENCY_ID]: selectCurrencyID,
                [PARAMS.SETTLEMETHOD]: settleMethod,
                [PARAMS.STATEMENTREMARK]: remark,
                [PARAMS.PAGEID]:String(pageID)
            }
            if (settleMethod === CHEQUE && !defaultBankAccount) {
                params[PARAMS.BANKACCOUNT] = inputBankAccount;
                params[PARAMS.BANKID] = inputBankID;
            } else {
                params[PARAMS.BANKACCOUNT] = selectWBankAC.bankACID;
                params[PARAMS.BANKID] = selectWBankAC.bankID;
            }
            if (isModify) {
                params[PARAMS.INSTRUCTIONID] = modifyFundData.transactionID;
            }
            this.props.cashDWAction(params, res => {
                if (res.result.errorCode === servicesResp.SUCCESS_CODE) {
                    if(res.result.isSuccess === 'Y'){
                        let transactionID = res.result.transactionID;
                        if (isModify) {
                            transactionID = modifyFundData.transactionID;
                        }
                        this.resetOption();
                        this.setWithdrawableBalance()
                        opencashDWResultDialog(transactionID, pageID, isModify);
                        if(isModify) {
                            this.props.closeLayout()
                            this.props.toggleRefreshTable(true)
                        }
                    }else{
                        this.setState({
                            errorMessage: res.result.errorMessage
                        })
                    }
                } else {
                    this.setState({
                        errorMessage: res.result.errorMessage
                    })
                }
                this.setState({isLoading : false})
            })
        }
    }

    componentDidMount() {
        const { ccy , isModify , modifyFundData} = this.props;
        this.setState({
            selectCurrencyID: ccy[0].value
        }, () => {
            this.CurrencyIDToBankAC([ccy[0]]);
            if(isModify){
                this.setModifyDW(isModify,modifyFundData)
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pageID != this.props.pageID) {
            this.setState({
                settleMethod: CHEQUE
            })
        }
        if (prevProps.accountBalance !== this.props.accountBalance) {
            this.setWithdrawableBalance();
        }
    }

    setWithdrawableBalance = () => {
        const { selectCurrencyID } = this.state;
        let params = {
            [PARAMS.CURRENCY_ID]:selectCurrencyID
        }
        this.props.withdrawableBalanceEnquiry(params, res=>{
            if(res.result.drawableBalance && res.result.drawableBalance !== ''){
                this.setState({
                    withdrawableBalance:res.result.drawableBalance
                })
            }else{
                this.setState({
                    withdrawableBalance:'-'
                })
            }
        })
    }

    CurrencyIDToBankAC = (val) => {
        const { withdrawalBankAccount } = this.props;
        const currencyID = val[0].value;
        let newWithdrawalBankAccount = [];
        withdrawalBankAccount.map((item, index) => {
            if (item.currencyID === currencyID) {
                newWithdrawalBankAccount.push(item)
            }
        })
        this.setState({
            withdrawalBankAccountOption: newWithdrawalBankAccount,
            selectWBankAC: newWithdrawalBankAccount[0],
            selectCurrencyID: currencyID
        }, () => {
            this.setWithdrawableBalance();
            let amountValue = this.amountInput.value;
            if(amountValue !==''){
                this.cashDepositWithdrawalFeeEnquiry(()=>{
                    this.setState({
                        creditedAmount: amountValue - this.state.fee
                    })
                })
            }
        })
    }

    selectBankAC = (val) => {
        this.setState({
            selectWBankAC: val[0]
        })
    }

    setModifyDW = (isModify, modifyFundData) => {
        const { ccy, settleMethodOption } = this.props;
        this.setState({
            isModify: isModify,
            modifyFundData: modifyFundData,
            errorMessage: ''
        }, () => {
            settleMethodOption.map(item => {
                if (item.value === modifyFundData.settleMethod) {
                    this.settleMethodOptionWithdrawalRef.setValue([item]);
                }
            })
            ccy.map(ccyItem => {
                if (ccyItem.value === modifyFundData.currencyID) {
                    this.withdrawalCurrencyIDOption.setValue([ccyItem]);
                    this.setState({
                        settleMethod: modifyFundData.settleMethod,
                        selectCurrencyID: ccyItem.value,
                        amount: Number(modifyFundData.amount).toFixed(3),
                        remark: modifyFundData.remark,
                        operation: MODIFY
                    })
                }
            })

        })
    }

    setSettleMethodOption() {
        const { settleMethodOption } = this.props;
        const { settleMethod } = this.state;
        let SettleMethodOption;
        settleMethodOption.map(item => {
            if (item.value === settleMethod) {
                SettleMethodOption = [item]
            }
        })
        return SettleMethodOption;
    }

    render() {
        const { language, ccy, pageID, settleMethodOption } = this.props
        const { settleMethod, amount, defaultBankAccount, withdrawalBankAccountOption, withdrawableBalance, selectCurrencyID, errorMessage, isModify, modifyFundData, TTCcrency, inputBankAccount, inputBankID, creditedAmount, fee , isLoading} = this.state;
        return (
            <div>
                <div className='fundmanagement-withdrawal-container'>
                    <LoadingLayer load={isLoading} type={LOADING_TYPE.BIG_IMG} />
                    <div className={classnames('cash-deposit','fund-container' ,'fund-container-withdrawal')}>
                        {errorMessage && <div className={classnames('fund-item')}>
                            <Tips isNoBgColor={true} isSuccess={false}>{errorMessage}</Tips>
                        </div> }
                        {isModify && <div className={classnames('fund-modify')}>
                            <div className={classnames('fund-modify-text')}>
                                {getSafe(() => language.fund_management_modify_text_withdrawal)}
                            </div>
                            <div className={classnames('fund-modify-reference-no')}>
                                {getSafe(() => language.fund_management_cash_reference)} &nbsp;
                                {modifyFundData.transactionID}
                            </div>
                        </div>}
                        <div className={classnames('fund-item')}>
                            <div className={classnames('fund-item-left')}>
                                {getSafe(() => language.fund_management_cash_bank_account)}
                            </div>
                            {withdrawalBankAccountOption.length !== 0 ?
                                <div className={classnames('fund-item-right')}>
                                    <Dropdown
                                        style={{ height: '30px', backgroundColor: 'transparent' }}
                                        selectedOptions={[withdrawalBankAccountOption[0]]}
                                        options={withdrawalBankAccountOption}
                                        onChange={(val) => this.selectBankAC(val)}
                                        innerRef={e => this.withdrawalBankAcctRef = e}
                                    />
                                </div> : '-'}
                        </div>
                        <div className={classnames('fund-item')}>
                            <div className={classnames('fund-item-left')}>
                                {getSafe(() => language.fund_management_settle_method_withdrawal)}
                            </div>
                            <div className={classnames('fund-item-right-radio')}>
                                <div className={classnames('settleMethodOption')}>
                                    <Dropdown
                                        style={{ height: '30px', flex: '0 0 70px', backgroundColor: 'transparent' }}
                                        selectedOptions={this.setSettleMethodOption()}
                                        options={settleMethodOption}
                                        onChange={(val) => this.selectSettleMethod(val)}
                                        innerRef={(e) => this.settleMethodOptionWithdrawalRef = e}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={classnames('fund-item', 'fund-item-amount')}>
                            <div className={classnames('fund-item-left')}>
                                {getSafe(() => language.fund_management_amount)}
                            </div>
                            <div className={classnames('fund-item-right-deposit-amount', 'fund-combine')}>
                                <div className={classnames('ccy')}>
                                    <Dropdown
                                        style={{ height: '30px', flex: '0 0 70px', backgroundColor: 'transparent' }}
                                        selectedOptions={[ccy[0]]}
                                        options={ccy}
                                        onChange={(val) => this.CurrencyIDToBankAC(val)}
                                        innerRef={(e) => this.withdrawalCurrencyIDOption = e}
                                    />
                                </div>
                                <input
                                    type="text"
                                    placeholder={getSafe(() => language.fund_management_enter_amount)}
                                    ref={(input) => this.amountInput = input}
                                    onInput={this.inputAmount}
                                    onBlur={this.formatNumber.bind(this)}
                                    value={amount} 
                                    />
                                {withdrawableBalance !== '-' && <div className={classnames('fund-item-withdrawable-cash-right')}
                                onClick={() => this.withdrawalAll()}>
                                {getSafe(() => language.mobile_fund_management_withdrawal_all)}
                            </div>}
                            </div>
                        </div>
                        <div className={classnames('fund-item-withdrawable-cash')}>
                            <div className={classnames('fund-item-withdrawable-cash-left')}>
                                {getSafe(() => language.fund_management_withdrawal_balance)}:&nbsp;
                            </div>
                            <div className={classnames('fund-item-withdrawable-cash-right')}>
                                {withdrawableBalance !== '-' && selectCurrencyID}&nbsp;
                                {formatFunctions.dataFormat(withdrawableBalance,dataType.CASH)}
                            </div>
                        </div>
                    </div>
                    <div className={classnames('fund-withdrawal-container-right')}>
                        <div className={classnames('fund-item')}>
                            <div className={classnames('fund-item-left')} style={{ marginBottom: '10px' }}  >
                                {getSafe(() => language.fund_management_remark)}
                            </div>
                            <textarea
                                style={{ fontSize:'14px', width: '100%' }}
                                className={classnames('fund-item-right')}
                                placeholder={getSafe(() => language.fund_management_optional)}
                                value={this.state.remark}
                                onChange={(e) => { this.setState({ remark: e.target.value }) }}>
                            </textarea>
                        </div>
                        <div className={classnames('fund-action-panel' , isModify && 'fund-action-panel-modify')}>
                            <button
                                className={classnames('fund-cancel')}
                                onClick={() => this.resetOption()}>
                                {getSafe(() => language.common_clear, '')}
                            </button>
                            <button
                                className={classnames('fund-submit')}
                                disabled= {isLoading ? 'disabled' : '' }
                                onClick={() => this.cashSubmit()}>
                                { isLoading ? <Icons.Loading /> : getSafe(() => language.common_button_submit, '')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        language: state.app.language,
        currentTradingAccount: state.trade.currentTradingAccount,
        user: state.auth.user,
        OtherWithdrawalBankAccount:state.trade.OtherWithdrawalBankAccount,
        withdrawalBankAccount:state.trade.WithdrawalBankAccount,
    }),
    dispatch => ({
        cashDWAction: (p, res) => dispatch(fundActions.cashDWAction(p, res)),
        withdrawableBalanceEnquiry:(p,res) => dispatch(fundActions.withdrawableBalanceEnquiryAction(p,res)),
        cashDepositWithdrawalFeeEnquiry: (p, c) => dispatch(fundActions.cashDepositWithdrawalFeeEnquiryAction(p, c)),
        toggleRefreshTable: (p) => dispatch({
            type: REFRESH_DATA.IPO_ACTION,
            value: p
          }),
    })
)(FundManagementWithdrawal)